import styled from 'styled-components';

const H3 = styled.h3`
color: #405e7b;
`;

export default H3;